<template>
  <v-app light>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style>
.v-expansion-panel__header {
  background: radial-gradient(
      ellipse farthest-corner at right bottom,
      #fedb37 0%,
      #fdb931 8%,
      #9f7928 30%,
      #8a6e2f 40%,
      transparent 80%
    ),
    radial-gradient(
      ellipse farthest-corner at left bottom,
      #d1b464 0%,
      #5d4a1f 62.5%,
      #5d4a1f 100%
    ) !important;

  background-clip: text;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.v-expansion-panel__header__icon i {
  background: radial-gradient(
      ellipse farthest-corner at right bottom,
      #fedb37 0%,
      #fdb931 8%,
      #9f7928 30%,
      #8a6e2f 40%,
      transparent 80%
    ),
    radial-gradient(
      ellipse farthest-corner at left bottom,
      #d1b464 0%,
      #5d4a1f 62.5%,
      #5d4a1f 100%
    ) !important;

  background-clip: text;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.v-input__slot{
    background: transparent !important;
}
/* unselectable text */
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Aiming to solve safari input editing problems */
input,
input:before,
input:after {
  -webkit-user-select: initial;
  -khtml-user-select: initial;
  -moz-user-select: initial;
  -ms-user-select: initial;
  user-select: initial;
}

textarea,
textarea:before,
textarea:after {
  -webkit-user-select: initial;
  -khtml-user-select: initial;
  -moz-user-select: initial;
  -ms-user-select: initial;
  user-select: initial;
}

.v-input__control {
  min-height: 20px !important;
}

@media only screen and (min-width: 700px) {
  .v-input__control {
    min-height: 48px !important;
  }
}

/* Vuetify snackbar height modified */
.v-snack__content {
  height: 80px !important;
}

.v-snack--vertical .v-snack__content {
  padding: 18px 14px !important;
}

/* Vuetify form labels modified */
.theme--light.v-label {
  color: #424242;
}

/* Vuetify list tile padding modified */
.v-list__group__items--no-action .v-list__tile {
  padding-left: 32px !important;
}

/* Override Vuetify parallax opacity */
.v-parallax__image-container {
  opacity: 0.65 !important;
}

.theme--light.v-list .v-list__tile__sub-title {
  overflow: hidden !important;
  max-height: 65px !important;
  height: 65px !important;
}

/* Recommended css code for vue-svgicon */
.svg-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  color: inherit;
  vertical-align: middle;
  fill: none;
  stroke: currentColor;
}

.svg-fill {
  fill: currentColor;
  stroke: none;
}

.svg-up {
  /* default */
  transform: rotate(0deg);
}

.svg-right {
  transform: rotate(90deg);
}

.svg-down {
  transform: rotate(180deg);
}

.svg-left {
  transform: rotate(-90deg);
}

.terms {
  text-decoration: none;
  font-family: Roboto, sans-serif;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue